import { render, staticRenderFns } from "./GasReading.vue?vue&type=template&id=70117920&"
import script from "./GasReading.vue?vue&type=script&lang=js&"
export * from "./GasReading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GasReading.vue"
export default component.exports